import { StrongTranslationString } from "src/ui/widgets/mixed-translation-string/mixed-translation-string";
import { usePaymentOk } from "./payment-ok.hook";
import { Button, Recaptcha } from "src/ui/widgets";
import { LeftArrowIcon, RightArrowIcon } from "src/assets";
import { Loader } from "react-bootstrap-typeahead";

export const PaymentOk = ({ email }: { email: string }) => {
  const { loading, t, navigateToHome, generateRecaptcha } = usePaymentOk();

  return (
    <div className="payment-result-container">
      <Recaptcha />
      <div className="mb-3 title">
        <StrongTranslationString i18nKey="payment.success_title" />
      </div>
      <div className="body">
        <div>{t("payment.success_subtitle_1")}</div>
        <div>{t("payment.success_subtitle_2", { email: email })}</div>
      </div>

      <div className="buttons-container">
        <Button
          text={t("payment.go_back_itasgive")}
          iconLeft={LeftArrowIcon}
          classes="m-0 p-0"
          flavor="transparentAccentBack"
          classesIconLeft="filter-00686F me-2"
          onPress={navigateToHome}
        />

        {loading ? (
          <div className="d-flex justify-content-center mb-3">
            <Loader />
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <Button
              text={t("payment.save_certificate")}
              iconRight={RightArrowIcon}
              classes="primary"
              onPress={generateRecaptcha}
            />
          </div>
        )}
      </div>
    </div>
  );
};
